import _typeof from "@babel/runtime-corejs2/helpers/typeof";
import React from 'react';
export var mergeRefs = function mergeRefs(forwardedRef) {
  var ref, setRef; // Check the shape of forwardedRef prop so we can properly pass it
  // through as expected while also making use of the ref ourselves
  // (i.e. support React.createRef() as well as functional refs)

  if (forwardedRef && _typeof(forwardedRef) === 'object' && 'current' in forwardedRef) {
    // if given a compatible forwardedRef, just use it
    setRef = ref = forwardedRef;
  } else {
    // otherwise create our own
    ref = /*#__PURE__*/React.createRef();

    if (typeof forwardedRef === 'function') {
      // if given a functional forwardedRef, combine it with ours
      setRef = function setRef(el) {
        forwardedRef(el);
        ref.current = el;
      };
    } else {
      // otherwise just set ours directly
      setRef = ref;
    }
  }

  return {
    ref: ref,
    setRef: setRef
  };
};
export default mergeRefs;